module.exports = __webpack_public_path__ + "static/media/SharedBlueWithFiles.1138119f.svg";